import axios from './index';

export interface ServiceConfigListParams {
    page?: string | number;
    size?: string | number;
    [property: string]: any;
}

export interface ServiceConfigPageMeta {
    cursor: string;
    more: boolean;
    page?: number | null;
    size: number;
    total: number;
    [property: string]: any;
}

export interface ServiceConfigItem {
    created_at: string;
    deleted_at?: string | null;
    id: string;
    key: string;
    module?: string;
    type: 'private' | 'public';
    updated_at: string;
    value: any;
    /** 乐观锁版本号：每次更新自增，用于并发冲突检测 */
    version?: number;
    [property: string]: any;
}

export interface ServiceConfigListResponse {
    code: number;
    data?: ServiceConfigItem[];
    errors?: any;
    meta?: ServiceConfigPageMeta | null;
    msg: string;
    [property: string]: any;
}

export interface ServiceConfigPayload {
    id?: string;
    key: string;
    module?: string;
    type: 'private' | 'public';
    value: any;
    /** 乐观锁版本号，更新时必传，创建时可忽略 */
    version?: number;
    [property: string]: any;
}

/**
 * 判断接口响应/错误是否属于"乐观锁版本冲突"。
 * 后端最终协议确定后，仅需在此处调整匹配规则。
 *
 * 当前兼容：
 *   - HTTP 409 Conflict
 *   - 业务码 40901 / 4091（占位，待后端确认）
 */
export const isServiceConfigVersionConflict = (source: unknown): boolean => {
    if (!source || typeof source !== 'object') return false;

    const anySource = source as any;

    const status = anySource.response?.status ?? anySource.status;
    if (status === 409) return true;

    const code = anySource.response?.data?.code ?? anySource.data?.code ?? anySource.code;
    if (code === 40901 || code === 4091) return true;

    return false;
};

export interface ServiceConfigMutationResponse {
    code: number;
    data?: any;
    errors?: any;
    meta?: null;
    msg: string;
    [property: string]: any;
}

export interface ServiceConfigDetailResponse {
    code: number;
    data?: ServiceConfigItem;
    errors?: any;
    meta?: null;
    msg: string;
    [property: string]: any;
}

export const serviceConfigList = (params: ServiceConfigListParams) =>
    axios<ServiceConfigListResponse>('/v1/configs', {
        method: 'get',
        params,
    });

export const serviceConfigCreate = (data: ServiceConfigPayload) =>
    axios<ServiceConfigMutationResponse>('/v1/configs', {
        method: 'post',
        data,
    });

export const serviceConfigUpdate = (id: string, data: Partial<ServiceConfigPayload>) =>
    axios<ServiceConfigMutationResponse>(`/v1/configs/${id}`, {
        method: 'patch',
        data: {
            ...data,
        },
    });

export const serviceConfigDelete = (id: string) =>
    axios<ServiceConfigMutationResponse>(`/v1/configs/${id}`, {
        method: 'delete',
    });

export const serviceConfigDetail = (id: string) =>
    axios<ServiceConfigDetailResponse>(`/v1/configs/${id}`, {
        method: 'get',
    });
